<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.emailTemplates.emailTemplates') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('settings.backToSettings') }}
        </d-button>
        <d-button theme="success" @click.prevent="$router.push('/ustawienia/szablony-email/nowy')">
          <i class="material-icons">add</i>
          {{ $t('settings.emailTemplates.addNewEmailTemplate') }}
        </d-button>
      </d-col>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0" style="width: 150px">{{ $t('settings.emailTemplates.languageCode') }}</th>
            <th scope="col" class="border-0" style="width: 40%;">{{ $t('settings.emailTemplates.footerImage') }}</th>
            <th scope="col" class="border-0">{{ $t('settings.emailTemplates.additionalInfo') }}</th>
            <th scope="col" class="border-0" style="width: 150px;">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(template, index) of templates"
            :key="'template-' + index">
            <td class="align-middle">
              {{ template.language_code }}
            </td>
            <td class="align-middle">
              <img :src="template.footer_image_url" style="max-width: 100%; height: auto; display: block;" />

              <small class="d-block mt-2">
                {{ $t('settings.emailTemplates.footerUrl') }}:<br>
                <a
                  v-if="template.footer_url"
                  :href="template.footer_url"
                  target="_blank">
                  {{ template.footer_url }}
                </a>
                <template v-else>
                  &mdash;
                </template>
              </small>
            </td>
            <td
              class="align-middle">
              <d-badge
                v-if="template.excluded_customers_count > 0"
                class="mb-2"
                theme="warning">
                {{ $t('settings.emailTemplates.excludedCustomersInfo') }}: {{ template.excluded_customers_count }}
              </d-badge>
              <small class="d-block">
                {{ template.company_name }}<br>
                {{ template.address_1 }}<br>
                {{ template.address_2 }}<br>
                {{ template.url }}<br>
                {{ template.email }}<br>
                {{ template.phone }}<br>
                {{ template.facebook_url }}<br>
                {{ template.youtube_url }}<br>
                {{ template.linkedin_url }}<br>
                {{ template.instagram_url }}<br>
              </small>
            </td>
            <td
              class="align-middle">
              <d-button
                theme="primary"
                @click.native="$router.push('/ustawienia/szablony-email/edycja/' + template.id)"
                class="mr-2"
                :title="$t('ui.edit')">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                :disabled="removeInProgress"
                @click.native="removeTemplate(template.id)"
                :title="$t('ui.delete')">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
        </tbody>
        <tbody v-if="templates.length === 0">
          <tr>
            <td
              colspan="3"
              class="text-center">
              {{ $t('settings.emailTemplates.noEmailTemplatesToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-card>
  </d-container>
</template>

<script>
import ListUtils from './../utils/ListUtils.js';

export default {
  name: 'email-templates',
  data() {
    return {
      templates: [],
      loaded: false,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      ListUtils.loadItemsData(this, '/email-templates/items', 'templates', { return: 'get' });
    },
    removeTemplate (templateID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/email-templates/delete/',
        id: templateID,
        successTitle: this.$t('settings.emailTemplates.removeEmailTemplateSuccessTitle'),
        successText: this.$t('settings.emailTemplates.removeEmailTemplateSuccessText'),
        confirmTitle: this.$t('settings.emailTemplates.removeEmailTemplteConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.emailTemplates.removeEmailTemplateErrorText'),
        successAction: () => {
          this.removeInProgress = false;
          this.loadData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>
